export default function formatRate(num) {
  let formattedNum = num.toFixed(1);
  if (formattedNum.endsWith('.0')) {
    formattedNum = formattedNum.slice(0, -2);
  }
  return formattedNum;
}
